module.exports = __webpack_public_path__ + "img/unfold-icon-4.6125c60b.png";